(function () {
  if (customElements.get('sample-box-picker')) return;

  const routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // const TOAST_ICONS = {
  //   added:
  //     '<svg viewBox="0 0 20 20" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="9" fill="#fff" fill-opacity="0.18"/><path d="M6 10.2l2.6 2.6L14.2 7" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  //   removed:
  //     '<svg viewBox="0 0 20 20" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="9" fill="#fff" fill-opacity="0.18"/><path d="M6.5 10h7" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/></svg>',
  //   error:
  //     '<svg viewBox="0 0 20 20" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="9" fill="#fff" fill-opacity="0.18"/><path d="M10 6v5" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/><circle cx="10" cy="13.6" r="1" fill="#fff"/></svg>',
  // };

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    }[c]));
  }

  function splitSelectors(str) {
    return String(str || '')
      .split('|')
      .map((s) => s.trim())
      .filter(Boolean);
  }

  /* ------------ Watch cart changes made by OTHER scripts (theme cart drawer, quick add...) ------------ */
  // Our own requests carry an "X-Sample-Box: 1" header and are ignored here; everything else that
  // adds/changes/clears the cart announces itself through the "sample-box:cart-changed" event.
  const CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  const OWN_HEADERS = { 'X-Sample-Box': '1' };

  function notifyCartChanged() {
    document.dispatchEvent(new CustomEvent('sample-box:cart-changed'));
  }

  if (!window.__sampleBoxCartWatcher) {
    window.__sampleBoxCartWatcher = true;

    const nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      const promise = nativeFetch.apply(this, arguments);
      try {
        const url = typeof input === 'string' ? input : (input && (input.url || input.href)) || '';
        const headers = (init && init.headers) || (input && input.headers);
        const isOwn =
          headers && (typeof headers.get === 'function' ? headers.get('X-Sample-Box') === '1' : headers['X-Sample-Box'] === '1');
        if (CART_MUTATION_RE.test(url) && !isOwn) {
          promise.then((res) => { if (res && res.ok) notifyCartChanged(); }).catch(() => {});
        }
      } catch (e) { /* never break the theme's own requests */ }
      return promise;
    };

    const nativeOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (CART_MUTATION_RE.test(String(url))) {
          this.addEventListener('load', () => {
            if (this.status >= 200 && this.status < 300) notifyCartChanged();
          });
        }
      } catch (e) { /* ignore */ }
      return nativeOpen.apply(this, arguments);
    };
  }

  class SampleBoxPicker extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.maxSamples = parseInt(this.dataset.maxSamples, 10) || 5;
      // A cart line counts as a "sample" when its variant has this option value
      // (e.g. "Buy Sample"), no matter where it was added from (product page, quick add, this page).
      this.sampleOptionValue = this.dataset.sampleOptionValue || 'Buy Sample';
      this.sidebarWrap = this.querySelector(`#sample-box-sidebar-${this.sectionId}`);
      this.stickybarWrap = this.querySelector(`#sample-box-stickybar-${this.sectionId}`);
      // this.toast = this.querySelector(`#sample-box-toast-${this.sectionId}`);
      this.busy = false;
      // this._toastTimer = null;
      this._stickybarTimer = null;
      this._themeCartTimer = null;

      // Theme cart drawer / header cart count refresh (selectors come from section settings, "|" separated).
      this.drawerSelectors = splitSelectors(this.dataset.drawerSelectors);
      this.countSelectors = splitSelectors(this.dataset.countSelectors);

      // Floating bar auto-hide behavior, driven by section settings.
      this.stickybarAutoHide = this.dataset.stickybarAutohide === 'true';
      this.stickybarDelay = parseInt(this.dataset.stickybarDelay, 10) || 5000;

      // Infinite scroll state (shared page counter — Shopify's paginate tag
      // reads the same ?page= query param for every collection on the page).
      this.currentPage = 1;
      this.loadingMore = false;

      this._onClick = this.handleClick.bind(this);
      this.addEventListener('click', this._onClick);

      // Back/forward navigation can restore a cached copy of this page — re-sync with the real cart.
      this._onPageShow = (event) => {
        if (event.persisted) {
          this.refreshSidebar().catch(() => {});
          this.syncSwatchStates();
        }
      };
      window.addEventListener('pageshow', this._onPageShow);

      // Cart changed somewhere else (e.g. an item removed inside the theme cart drawer) — mirror it here.
      this._externalTimer = null;
      this._onExternalCartChange = () => {
        clearTimeout(this._externalTimer);
        this._externalTimer = setTimeout(async () => {
          if (this.busy) return;
          try {
            await this.refreshSidebar({ syncTheme: false });
            this.syncSwatchStates();
          } catch (err) {
            console.warn('[sample-box] external cart sync failed', err);
          }
        }, 200);
      };
      document.addEventListener('sample-box:cart-changed', this._onExternalCartChange);

      this.syncSwatchStates();
      this.maybeAutoHideStickybar();
      this.setupInfiniteScroll();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      window.removeEventListener('pageshow', this._onPageShow);
      document.removeEventListener('sample-box:cart-changed', this._onExternalCartChange);
      // clearTimeout(this._toastTimer);
      clearTimeout(this._stickybarTimer);
      clearTimeout(this._themeCartTimer);
      clearTimeout(this._externalTimer);
      this._sentinelObserver?.disconnect();
    }

    isSampleItem(item) {
      return Array.isArray(item.variant_options) && item.variant_options.includes(this.sampleOptionValue);
    }

    handleClick(event) {
      const swatchBtn = event.target.closest('.sample-box-card__swatch');
      if (swatchBtn && !swatchBtn.disabled) {
        event.preventDefault();
        this.toggleSample(swatchBtn);
        return;
      }

      const removeBtn = event.target.closest('[data-remove-line]');
      if (removeBtn) {
        event.preventDefault();
        this.removeLine(removeBtn.dataset.removeLine);
        return;
      }

      const tabBtn = event.target.closest('.sample-box-tab');
      if (tabBtn) {
        event.preventDefault();
        this.switchTab(tabBtn);
        return;
      }

      const stickybarCloseBtn = event.target.closest('.sample-box-stickybar__close');
      if (stickybarCloseBtn) {
        event.preventDefault();
        this.dismissStickybar();
        return;
      }
    }

    switchTab(button) {
      if (button.classList.contains('is-active')) return;
      const targetId = button.dataset.tabTarget;

      this.querySelectorAll('.sample-box-tab').forEach((btn) => {
        const active = btn === button;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      this.querySelectorAll('.sample-box-tabpanel').forEach((panel) => {
        panel.hidden = panel.id !== targetId;
      });

      button.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    /* ---------------- Infinite scroll ---------------- */

    setupInfiniteScroll() {
      const sentinels = this.querySelectorAll('.sample-box-load-sentinel');
      if (!sentinels.length) return;

      this._sentinelObserver = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.loadMoreProducts();
          }
        },
        { rootMargin: '400px 0px 400px 0px' }
      );

      sentinels.forEach((el) => this._sentinelObserver.observe(el));
    }

    anyPanelHasNextPage() {
      return [...this.querySelectorAll('.sample-box-tabpanel')].some(
        (p) => p.dataset.hasNextPage === 'true'
      );
    }

    async loadMoreProducts() {
      if (this.loadingMore || !this.anyPanelHasNextPage()) {
        if (!this.anyPanelHasNextPage()) this._sentinelObserver?.disconnect();
        return;
      }

      this.loadingMore = true;
      this.currentPage += 1;
      this.querySelectorAll('.sample-box-load-sentinel').forEach((el) => el.classList.add('is-loading'));

      try {
        const url = `${window.location.pathname}?section_id=${this.sectionId}&page=${this.currentPage}`;
        const html = await fetch(url).then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');

        this.querySelectorAll('.sample-box-tabpanel').forEach((panel) => {
          const newPanel = doc.getElementById(panel.id);
          if (!newPanel) return;

          panel.dataset.hasNextPage = newPanel.dataset.hasNextPage || 'false';

          const sentinel = panel.querySelector('.sample-box-load-sentinel');
          newPanel.querySelectorAll('.sample-box-card').forEach((card) => {
            panel.insertBefore(card.cloneNode(true), sentinel);
          });
        });

        this.syncSwatchStates();
      } catch (err) {
        console.error('[sample-box] load more failed', err);
      } finally {
        this.loadingMore = false;
        this.querySelectorAll('.sample-box-load-sentinel').forEach((el) => el.classList.remove('is-loading'));
        if (!this.anyPanelHasNextPage()) this._sentinelObserver?.disconnect();
      }
    }

    /* ---------------- Sticky bar ---------------- */

    /** Manually closing just hides this instance — the next cart change re-renders a fresh (visible) bar. */
    dismissStickybar() {
      clearTimeout(this._stickybarTimer);
      const bar = this.stickybarWrap?.querySelector('.sample-box-stickybar');
      if (bar) bar.classList.remove('is-visible');
    }

    /** Starts (or skips) the auto-hide timer for whatever sticky bar is currently rendered. */
    maybeAutoHideStickybar() {
      clearTimeout(this._stickybarTimer);
      if (!this.stickybarAutoHide || !this.stickybarWrap) return;
      const bar = this.stickybarWrap.querySelector('.sample-box-stickybar.is-visible');
      if (!bar) return;
      this._stickybarTimer = setTimeout(() => {
        bar.classList.remove('is-visible');
      }, this.stickybarDelay);
    }

    /* ---------------- Sample selection ---------------- */

    /** Swaps the card's displayed image to the clicked swatch's variant image (if it has one). */
    updateCardImage(button) {
      const imageUrl = button.dataset.variantImage;
      if (!imageUrl) return;

      const card = button.closest('.sample-box-card');
      const img = card?.querySelector('.sample-box-card__image img');
      if (!img) return;

      img.src = imageUrl;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
    }

    getCurrentSampleCount() {
      return this.sidebarWrap.querySelectorAll('.sample-box__item').length;
    }

    async toggleSample(button) {
      if (this.busy) return;

      this.updateCardImage(button);

      const variantId = button.dataset.variantId;
      const isSelected = button.classList.contains('is-selected');

      if (!isSelected && this.getCurrentSampleCount() >= this.maxSamples) {
        // this.showToast('error', 'Your sample box is full — remove a sample to add a new one.');
        console.warn('[sample-box] Your sample box is full - remove a sample to add a new one.');
        return;
      }

      this.busy = true;
      button.classList.add('is-loading');

      try {
        if (isSelected) {
          await this.removeVariantFromCart(variantId);
          button.classList.remove('is-selected');
          // this.showToast('removed', `${button.dataset.productTitle} removed from your sample box`);
        } else {
          await this.addVariantToCart(variantId);
          button.classList.add('is-selected');
          // this.showToast('added', `${button.dataset.productTitle} added to your sample box`);
        }
        await this.refreshSidebar();
      } catch (err) {
        console.error('[sample-box]', err);
        // this.showToast('error', 'Something went wrong — please try again.');
      } finally {
        button.classList.remove('is-loading');
        this.busy = false;
      }
    }

    addVariantToCart(variantId) {
      // No custom line-item property: the same variant added from a product page and from here is one cart line.
      return fetch(`${routeRoot}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', ...OWN_HEADERS },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
        }),
      }).then((res) => {
        if (!res.ok) return res.json().then((data) => Promise.reject(new Error(data.description || 'Could not add sample')));
        return res.json();
      });
    }

    async removeVariantFromCart(variantId) {
      const cart = await fetch(`${routeRoot}cart.js`).then((r) => r.json());
      const updates = {};
      cart.items.forEach((item) => {
        if (String(item.variant_id) === String(variantId) && this.isSampleItem(item)) {
          updates[item.key] = 0;
        }
      });
      if (!Object.keys(updates).length) return;

      return fetch(`${routeRoot}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', ...OWN_HEADERS },
        body: JSON.stringify({ updates }),
      }).then((res) => {
        if (!res.ok) throw new Error('Cart update failed');
        return res.json();
      });
    }

    async removeLine(key) {
      if (this.busy) return;
      this.busy = true;

      // Grab a title before the DOM gets refreshed out from under us.
      const row = this.sidebarWrap.querySelector(`[data-line-key="${key}"]`);
      const title = row?.querySelector('.sample-box__item-title')?.textContent?.trim() || 'Sample';

      try {
        await this.changeLine(key, 0);
        await this.refreshSidebar();
        this.syncSwatchStates();
        // this.showToast('removed', `${title} removed from your sample box`);
      } catch (err) {
        console.error('[sample-box]', err);
        // this.showToast('error', 'Could not remove that sample — please try again.');
      } finally {
        this.busy = false;
      }
    }

    changeLine(key, quantity) {
      return fetch(`${routeRoot}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', ...OWN_HEADERS },
        body: JSON.stringify({ id: key, quantity }),
      }).then((res) => {
        if (!res.ok) throw new Error('Cart update failed');
        return res.json();
      });
    }

    async refreshSidebar({ syncTheme = true } = {}) {
      const url = `${window.location.pathname}?section_id=${this.sectionId}`;
      const html = await fetch(url).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newSidebar = doc.getElementById(`sample-box-sidebar-${this.sectionId}`);
      if (newSidebar && this.sidebarWrap) {
        this.sidebarWrap.innerHTML = newSidebar.innerHTML;
      }

      const newStickybar = doc.getElementById(`sample-box-stickybar-${this.sectionId}`);
      if (newStickybar && this.stickybarWrap) {
        this.stickybarWrap.innerHTML = newStickybar.innerHTML;
      }

      // Fresh markup means a fresh (visible-again) bar — (re)apply the auto-hide rule.
      this.maybeAutoHideStickybar();

      // Keep the theme's own cart drawer + header cart count in step with every add/remove
      // made here. (Changes that came FROM the theme drawer skip this — the drawer is already right.)
      if (syncTheme) this.scheduleThemeCartRefresh();
    }

    /* ---------------- Theme cart drawer sync ---------------- */

    /** Debounced so several quick adds trigger a single drawer refresh. Runs in the background (not awaited). */
    scheduleThemeCartRefresh() {
      clearTimeout(this._themeCartTimer);
      this._themeCartTimer = setTimeout(() => this.refreshThemeCart(), 250);
    }

    async refreshThemeCart() {
      try {
        const [cart, doc] = await Promise.all([
          fetch(`${routeRoot}cart.js`).then((r) => r.json()),
          this.fetchFreshDrawerDoc(),
        ]);

        // Header cart count: set straight from the real cart total.
        this.updateCartCount(cart.item_count);

        // Drawer: copy the freshly rendered drawer into the live page.
        if (doc) {
          for (const sel of this.drawerSelectors) {
            const oldEl = [...document.querySelectorAll(sel)].find((el) => !this.contains(el));
            const newEl = doc.querySelector(sel);
            if (oldEl && newEl) {
              this.swapElement(oldEl, newEl);
              break;
            }
          }
        }
      } catch (err) {
        console.warn('[sample-box] theme cart refresh failed', err);
      }
    }

    /**
     * Prefers the Section Rendering API for just the drawer section (light + fast), using the
     * data-section-id on the live <cart-drawer>. Falls back to re-reading this whole page.
     */
    async fetchFreshDrawerDoc() {
      if (!this.drawerSelectors.length) return null;

      let drawerEl = null;
      try {
        drawerEl = [...document.querySelectorAll(this.drawerSelectors.join(','))].find((el) => !this.contains(el));
      } catch (e) {
        return null; // invalid selector in settings
      }
      if (!drawerEl) return null;

      const sectionId = drawerEl.dataset && drawerEl.dataset.sectionId;
      if (sectionId) {
        try {
          const res = await fetch(`${routeRoot}?sections=${encodeURIComponent(sectionId)}`);
          if (res.ok) {
            const data = await res.json();
            if (data[sectionId]) return new DOMParser().parseFromString(data[sectionId], 'text/html');
          }
        } catch (e) { /* fall through to full page */ }
      }

      const res = await fetch(window.location.href, { headers: { Accept: 'text/html' } });
      return new DOMParser().parseFromString(await res.text(), 'text/html');
    }

    /**
     * Updates the header cart count bubble(s). Uses the selectors from the section settings when
     * given; otherwise looks for the usual "cart count / bubble / badge" elements.
     */
    updateCartCount(count) {
      const outside = (el) => !this.contains(el) && !el.closest('cart-drawer');
      let targets = [];

      if (this.countSelectors.length) {
        try {
          targets = [...document.querySelectorAll(this.countSelectors.join(','))].filter(outside);
        } catch (e) { /* invalid selector in settings */ }
      }

      if (!targets.length) {
        targets = [
          ...document.querySelectorAll(
            '[data-cart-count], [data-cart-count-bubble], [class*="cart"][class*="count"], [class*="cart"][class*="bubble"], [class*="cart"][class*="badge"]'
          ),
        ].filter(outside);
      }

      targets.forEach((el) => {
        // If the match wraps other elements, only touch the numeric leaf inside it.
        const leaves = el.children.length
          ? [...el.querySelectorAll('*')].filter((n) => !n.children.length && /^\s*\d+\s*$/.test(n.textContent))
          : [el];
        leaves.forEach((n) => { n.textContent = String(count); });
        if (count > 0) el.removeAttribute('hidden');
      });
    }

    /**
     * Custom elements (e.g. <cart-drawer>) are replaced whole so they re-initialise themselves;
     * plain elements keep their own event listeners and only get new inner HTML.
     */
    swapElement(oldEl, newEl) {
      if (oldEl.tagName.includes('-')) {
        oldEl.replaceWith(document.importNode(newEl, true));
      } else {
        oldEl.innerHTML = newEl.innerHTML;
      }
    }

    syncSwatchStates() {
      fetch(`${routeRoot}cart.js`)
        .then((r) => r.json())
        .then((cart) => {
          const activeVariantIds = cart.items
            .filter((item) => this.isSampleItem(item))
            .map((item) => String(item.variant_id));
          this.querySelectorAll('.sample-box-card__swatch').forEach((btn) => {
            btn.classList.toggle('is-selected', activeVariantIds.includes(btn.dataset.variantId));
          });
        })
        .catch(() => {});
    }

    // showToast(type, message) {
    //   if (!this.toast) return;
    //   const icon = TOAST_ICONS[type] || TOAST_ICONS.added;
    //   this.toast.innerHTML = `<span class="sample-box-toast__icon">${icon}</span><span class="sample-box-toast__text">${escapeHtml(message)}</span>`;
    //   this.toast.className = `sample-box-toast is-visible sample-box-toast--${type}`;
    //   clearTimeout(this._toastTimer);
    //   this._toastTimer = setTimeout(() => {
    //     this.toast.classList.remove('is-visible');
    //   }, 3500);
    // }
  }

  customElements.define('sample-box-picker', SampleBoxPicker);
})();


document.querySelectorAll('.sample-box-tabs').forEach((slider) => {
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('active');
  });

  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('active');
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;

    e.preventDefault();

    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 1.5;

    slider.scrollLeft = scrollLeft - walk;
  });
});

// (function () {
//   if (customElements.get('sample-box-picker')) return;

//   const routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

//   // const TOAST_ICONS = {
//   //   added:
//   //     '<svg viewBox="0 0 20 20" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="9" fill="#fff" fill-opacity="0.18"/><path d="M6 10.2l2.6 2.6L14.2 7" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
//   //   removed:
//   //     '<svg viewBox="0 0 20 20" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="9" fill="#fff" fill-opacity="0.18"/><path d="M6.5 10h7" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/></svg>',
//   //   error:
//   //     '<svg viewBox="0 0 20 20" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="9" fill="#fff" fill-opacity="0.18"/><path d="M10 6v5" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/><circle cx="10" cy="13.6" r="1" fill="#fff"/></svg>',
//   // };

//   function escapeHtml(str) {
//     return String(str || '').replace(/[&<>"']/g, (c) => ({
//       '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
//     }[c]));
//   }

//   class SampleBoxPicker extends HTMLElement {
//     connectedCallback() {
//       this.sectionId = this.dataset.sectionId;
//       this.maxSamples = parseInt(this.dataset.maxSamples, 10) || 5;
//       this.sidebarWrap = this.querySelector(`#sample-box-sidebar-${this.sectionId}`);
//       this.stickybarWrap = this.querySelector(`#sample-box-stickybar-${this.sectionId}`);
//       // this.toast = this.querySelector(`#sample-box-toast-${this.sectionId}`);
//       this.busy = false;
//       // this._toastTimer = null;
//       this._stickybarTimer = null;

//       // Floating bar auto-hide behavior, driven by section settings.
//       this.stickybarAutoHide = this.dataset.stickybarAutohide === 'true';
//       this.stickybarDelay = parseInt(this.dataset.stickybarDelay, 10) || 5000;

//       // Infinite scroll state (shared page counter — Shopify's paginate tag
//       // reads the same ?page= query param for every collection on the page).
//       this.currentPage = 1;
//       this.loadingMore = false;

//       this._onClick = this.handleClick.bind(this);
//       this.addEventListener('click', this._onClick);

//       this.syncSwatchStates();
//       this.maybeAutoHideStickybar();
//       this.setupInfiniteScroll();
//     }

//     disconnectedCallback() {
//       this.removeEventListener('click', this._onClick);
//       // clearTimeout(this._toastTimer);
//       clearTimeout(this._stickybarTimer);
//       this._sentinelObserver?.disconnect();
//     }

//     handleClick(event) {
//       const swatchBtn = event.target.closest('.sample-box-card__swatch');
//       if (swatchBtn && !swatchBtn.disabled) {
//         event.preventDefault();
//         this.toggleSample(swatchBtn);
//         return;
//       }

//       const removeBtn = event.target.closest('[data-remove-line]');
//       if (removeBtn) {
//         event.preventDefault();
//         this.removeLine(removeBtn.dataset.removeLine);
//         return;
//       }

//       const tabBtn = event.target.closest('.sample-box-tab');
//       if (tabBtn) {
//         event.preventDefault();
//         this.switchTab(tabBtn);
//         return;
//       }

//       const stickybarCloseBtn = event.target.closest('.sample-box-stickybar__close');
//       if (stickybarCloseBtn) {
//         event.preventDefault();
//         this.dismissStickybar();
//         return;
//       }
//     }

//     switchTab(button) {
//       if (button.classList.contains('is-active')) return;
//       const targetId = button.dataset.tabTarget;

//       this.querySelectorAll('.sample-box-tab').forEach((btn) => {
//         const active = btn === button;
//         btn.classList.toggle('is-active', active);
//         btn.setAttribute('aria-selected', active ? 'true' : 'false');
//       });

//       this.querySelectorAll('.sample-box-tabpanel').forEach((panel) => {
//         panel.hidden = panel.id !== targetId;
//       });

//       button.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
//     }

//     /* ---------------- Infinite scroll ---------------- */

//     setupInfiniteScroll() {
//       const sentinels = this.querySelectorAll('.sample-box-load-sentinel');
//       if (!sentinels.length) return;

//       this._sentinelObserver = new IntersectionObserver(
//         (entries) => {
//           if (entries.some((entry) => entry.isIntersecting)) {
//             this.loadMoreProducts();
//           }
//         },
//         { rootMargin: '400px 0px 400px 0px' }
//       );

//       sentinels.forEach((el) => this._sentinelObserver.observe(el));
//     }

//     anyPanelHasNextPage() {
//       return [...this.querySelectorAll('.sample-box-tabpanel')].some(
//         (p) => p.dataset.hasNextPage === 'true'
//       );
//     }

//     async loadMoreProducts() {
//       if (this.loadingMore || !this.anyPanelHasNextPage()) {
//         if (!this.anyPanelHasNextPage()) this._sentinelObserver?.disconnect();
//         return;
//       }

//       this.loadingMore = true;
//       this.currentPage += 1;
//       this.querySelectorAll('.sample-box-load-sentinel').forEach((el) => el.classList.add('is-loading'));

//       try {
//         const url = `${window.location.pathname}?section_id=${this.sectionId}&page=${this.currentPage}`;
//         const html = await fetch(url).then((r) => r.text());
//         const doc = new DOMParser().parseFromString(html, 'text/html');

//         this.querySelectorAll('.sample-box-tabpanel').forEach((panel) => {
//           const newPanel = doc.getElementById(panel.id);
//           if (!newPanel) return;

//           panel.dataset.hasNextPage = newPanel.dataset.hasNextPage || 'false';

//           const sentinel = panel.querySelector('.sample-box-load-sentinel');
//           newPanel.querySelectorAll('.sample-box-card').forEach((card) => {
//             panel.insertBefore(card.cloneNode(true), sentinel);
//           });
//         });

//         this.syncSwatchStates();
//       } catch (err) {
//         console.error('[sample-box] load more failed', err);
//       } finally {
//         this.loadingMore = false;
//         this.querySelectorAll('.sample-box-load-sentinel').forEach((el) => el.classList.remove('is-loading'));
//         if (!this.anyPanelHasNextPage()) this._sentinelObserver?.disconnect();
//       }
//     }

//     /* ---------------- Sticky bar ---------------- */

//     /** Manually closing just hides this instance — the next cart change re-renders a fresh (visible) bar. */
//     dismissStickybar() {
//       clearTimeout(this._stickybarTimer);
//       const bar = this.stickybarWrap?.querySelector('.sample-box-stickybar');
//       if (bar) bar.classList.remove('is-visible');
//     }

//     /** Starts (or skips) the auto-hide timer for whatever sticky bar is currently rendered. */
//     maybeAutoHideStickybar() {
//       clearTimeout(this._stickybarTimer);
//       if (!this.stickybarAutoHide || !this.stickybarWrap) return;
//       const bar = this.stickybarWrap.querySelector('.sample-box-stickybar.is-visible');
//       if (!bar) return;
//       this._stickybarTimer = setTimeout(() => {
//         bar.classList.remove('is-visible');
//       }, this.stickybarDelay);
//     }

//     /* ---------------- Sample selection ---------------- */

//     /** Swaps the card's displayed image to the clicked swatch's variant image (if it has one). */
//     updateCardImage(button) {
//       const imageUrl = button.dataset.variantImage;
//       if (!imageUrl) return;

//       const card = button.closest('.sample-box-card');
//       const img = card?.querySelector('.sample-box-card__image img');
//       if (!img) return;

//       img.src = imageUrl;
//       img.removeAttribute('srcset');
//       img.removeAttribute('sizes');
//     }

//     getCurrentSampleCount() {
//       return this.sidebarWrap.querySelectorAll('.sample-box__item').length;
//     }

//     async toggleSample(button) {
//       if (this.busy) return;

//       this.updateCardImage(button);

//       const variantId = button.dataset.variantId;
//       const isSelected = button.classList.contains('is-selected');

//       if (!isSelected && this.getCurrentSampleCount() >= this.maxSamples) {
//         // this.showToast('error', 'Your sample box is full — remove a sample to add a new one.');
//         console.error('Your sample box is full - remove a sample to add a new one.', err);
//         return;
//       }

//       this.busy = true;
//       button.classList.add('is-loading');

//       try {
//         if (isSelected) {
//           await this.removeVariantFromCart(variantId);
//           button.classList.remove('is-selected');
//           // this.showToast('removed', `${button.dataset.productTitle} removed from your sample box`);
//         } else {
//           await this.addVariantToCart(variantId);
//           button.classList.add('is-selected');
//           // this.showToast('added', `${button.dataset.productTitle} added to your sample box`);
//         }
//         await this.refreshSidebar();
//       } catch (err) {
//         console.error('[sample-box]', err);
//         // this.showToast('error', 'Something went wrong — please try again.');
//       } finally {
//         button.classList.remove('is-loading');
//         this.busy = false;
//       }
//     }

//     addVariantToCart(variantId) {
//       return fetch(`${routeRoot}cart/add.js`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
//         body: JSON.stringify({
//           items: [
//             {
//               id: variantId,
//               quantity: 1,
//               properties: { '_Sample Box': 'true' },
//             },
//           ],
//         }),
//       }).then((res) => {
//         if (!res.ok) return res.json().then((data) => Promise.reject(new Error(data.description || 'Could not add sample')));
//         return res.json();
//       });
//     }

//     async removeVariantFromCart(variantId) {
//       const cart = await fetch(`${routeRoot}cart.js`).then((r) => r.json());
//       const line = cart.items.find(
//         (item) => String(item.variant_id) === String(variantId) && item.properties && item.properties['_Sample Box'] === 'true'
//       );
//       if (!line) return;
//       return this.changeLine(line.key, 0);
//     }

//     async removeLine(key) {
//       if (this.busy) return;
//       this.busy = true;

//       // Grab a title before the DOM gets refreshed out from under us.
//       const row = this.sidebarWrap.querySelector(`[data-line-key="${key}"]`);
//       const title = row?.querySelector('.sample-box__item-title')?.textContent?.trim() || 'Sample';

//       try {
//         await this.changeLine(key, 0);
//         await this.refreshSidebar();
//         this.syncSwatchStates();
//         // this.showToast('removed', `${title} removed from your sample box`);
//       } catch (err) {
//         console.error('[sample-box]', err);
//         // this.showToast('error', 'Could not remove that sample — please try again.');
//       } finally {
//         this.busy = false;
//       }
//     }

//     changeLine(key, quantity) {
//       return fetch(`${routeRoot}cart/change.js`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
//         body: JSON.stringify({ id: key, quantity }),
//       }).then((res) => {
//         if (!res.ok) throw new Error('Cart update failed');
//         return res.json();
//       });
//     }

//     async refreshSidebar() {
//       const url = `${window.location.pathname}?section_id=${this.sectionId}`;
//       const html = await fetch(url).then((r) => r.text());
//       const doc = new DOMParser().parseFromString(html, 'text/html');

//       const newSidebar = doc.getElementById(`sample-box-sidebar-${this.sectionId}`);
//       if (newSidebar && this.sidebarWrap) {
//         this.sidebarWrap.innerHTML = newSidebar.innerHTML;
//       }

//       const newStickybar = doc.getElementById(`sample-box-stickybar-${this.sectionId}`);
//       if (newStickybar && this.stickybarWrap) {
//         this.stickybarWrap.innerHTML = newStickybar.innerHTML;
//       }

//       // Fresh markup means a fresh (visible-again) bar — (re)apply the auto-hide rule.
//       this.maybeAutoHideStickybar();

//       // Let the rest of the theme (cart bubble/drawer) know the cart changed.
//       document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
//     }

//     syncSwatchStates() {
//       fetch(`${routeRoot}cart.js`)
//         .then((r) => r.json())
//         .then((cart) => {
//           const activeVariantIds = cart.items
//             .filter((item) => item.properties && item.properties['_Sample Box'] === 'true')
//             .map((item) => String(item.variant_id));
//           this.querySelectorAll('.sample-box-card__swatch').forEach((btn) => {
//             btn.classList.toggle('is-selected', activeVariantIds.includes(btn.dataset.variantId));
//           });
//         })
//         .catch(() => {});
//     }

//     // showToast(type, message) {
//     //   if (!this.toast) return;
//     //   const icon = TOAST_ICONS[type] || TOAST_ICONS.added;
//     //   this.toast.innerHTML = `<span class="sample-box-toast__icon">${icon}</span><span class="sample-box-toast__text">${escapeHtml(message)}</span>`;
//     //   this.toast.className = `sample-box-toast is-visible sample-box-toast--${type}`;
//     //   clearTimeout(this._toastTimer);
//     //   this._toastTimer = setTimeout(() => {
//     //     this.toast.classList.remove('is-visible');
//     //   }, 3500);
//     // }
//   }

//   customElements.define('sample-box-picker', SampleBoxPicker);
// })();


// document.querySelectorAll('.sample-box-tabs').forEach((slider) => {
//   let isDown = false;
//   let startX;
//   let scrollLeft;

//   slider.addEventListener('mousedown', (e) => {
//     isDown = true;
//     slider.classList.add('active');
//     startX = e.pageX - slider.offsetLeft;
//     scrollLeft = slider.scrollLeft;
//   });

//   slider.addEventListener('mouseleave', () => {
//     isDown = false;
//     slider.classList.remove('active');
//   });

//   slider.addEventListener('mouseup', () => {
//     isDown = false;
//     slider.classList.remove('active');
//   });

//   slider.addEventListener('mousemove', (e) => {
//     if (!isDown) return;

//     e.preventDefault();

//     const x = e.pageX - slider.offsetLeft;
//     const walk = (x - startX) * 1.5;

//     slider.scrollLeft = scrollLeft - walk;
//   });
// });